module.exports = __webpack_public_path__ + "img/m.6b8151c1.jpg";